import React from 'react'

import { ActivityAndAccess } from 'pages/insights/activityAndAccess/ActivityAndAccess'

export const ActivityAndAccessContainer: React.FC = () => <ActivityAndAccess />
